import React, { useState } from 'react';
import { SearchBar } from 'antd-mobile';
import './SearchHeader.css';

interface SearchHeaderProps {
  placeholder?: string;
  onSearch?: (value: string) => void;
  onChange?: (value: string) => void;
}

const SearchHeader: React.FC<SearchHeaderProps> = ({ 
  placeholder = '搜索商品名称或编码', 
  onSearch,
  onChange
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleChange = (value: string) => {
    setSearchValue(value);
    onChange?.(value);
  };

  const handleSearch = (value: string) => {
    onSearch?.(value);
  };

  const handleClear = () => {
    setSearchValue('');
    onChange?.('');
  };

  return (
    <div className="search-header">
      <SearchBar 
        placeholder={placeholder}
        value={searchValue}
        onChange={handleChange}
        onSearch={handleSearch}
        onClear={handleClear}
        showCancelButton
        cancelText="取消"
      />
    </div>
  );
};

export default SearchHeader;
